export default "__VITE_ASSET__CGnAkkrY__"